import ticketDetails from '../localization-messages/ticketDetails/nl-BE.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/nl-BE.json';
import ticketListing from '../localization-messages/ticketListing/nl-BE.json';
import ticketForm from '../localization-messages/ticketForm/nl-BE.json';
import headerFooter from '../localization-messages/headerFooter/nl-BE.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/nl-BE.json';
import termsModal from '../localization-messages/termsModal/nl-BE.json';

export const nlBETranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
